import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setAnnoucementCount } from "../../repository/slice";

function* getAnnoucementCountWorker(): SagaIterator {
  try {
    yield put(setLoading(true));
    const { data, message, isError }: IResponse<any> = yield call(
      requester.get,
      "/api/admin/announcement-comments/unread-count"
    );
    if (!isError) {
      yield put(setAnnoucementCount(data.count));
    } else {
      console.error(message);
    }
  } catch (error) {
    console.error("getAnnoucementCountWorker: ", error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* getAnnoucementCountWatcher() {
  yield takeLatest("@saga/GET_ANNOUCEMENT_COUNT", getAnnoucementCountWorker);
}
